<template>
  <div>
    <div class="reg-t-select"><span class="reg-t-l">当前级别：{{ this.regName }}</span><router-link :to="{ name: 'register', query: { hid: hid }}"><span class="reg-t-r">重新选择</span></router-link></div>
    <div class="reg-shop">
      <div class="r-s-li" v-if="this.regType == 1">
        <img src="../../assets/images/01.jpg" />
        <h3 class="title">{{ this.regName }}套餐价格</h3>
        <div class="price-select">
          <van-radio-group v-model="regType">
            <span class="price">￥49800.00</span>
            <van-radio name="1" shape="square" class="select">选择</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="r-s-li" v-if="this.regType == 2">
        <img src="../../assets/images/01.jpg" />
        <h3 class="title">{{ this.regName }}套餐价格</h3>
        <div class="price-select">
          <van-radio-group v-model="regType">
            <span class="price">￥8800.00</span>
            <van-radio name="2" shape="square" class="select">选择</van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>
    <van-submit-bar :price="this.price" button-text="提交订单" @submit="regForm" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Button, RadioGroup, Radio, SubmitBar } from 'vant'

  export default {
    components: {
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [SubmitBar.name]: SubmitBar
    },
    name: 'Genre',
    data () {
      return {
        regName: '区域',
        regType: '1',
        price: 49800 * 100,
        hid: localStorage.getItem('hid')
      }
    },
    created: function () {
      this.regType = this.$route.params.type
      if(this.regType == 2){
        this.regName = '门店'
        this.price = 8800 * 100
      }
    },
    methods: {
      regForm() {
        this.$router.push('/register/form/'+this.regType)
      }
    },
  }
</script>

<style scoped>
  .reg-t-select{
    background: #fff;
    padding:15px;
    overflow: hidden;
  }
  .reg-t-l{
    float: left;
    margin-top: 8px;
  }
  .reg-t-r{
    float: right;
    background: #576B95;
    color:#ffffff;
    border-radius: 30px;
    padding:5px 15px;
    display: inline-block;
  }
  .reg-shop{
    overflow: hidden;
    padding:15px;
  }
  .reg-shop .r-s-li{
    background: #fff;
    padding:10px;
    border-radius: 8px;
    width: 50%;
    float: left;
  }
  .reg-shop .r-s-li img{
    width: 100%;
  }
  .reg-shop .r-s-li h3{
    font-size: 15px;
    color:#3e3f3f;
    margin: 10px 0;
  }
  .reg-shop .r-s-li .title{

  }
  .reg-shop .r-s-li .price-select{

  }
  .reg-shop .r-s-li .price-select .price{
    color:#ee0a24;
    float: left;
  }
  .reg-shop .r-s-li .price-select .select{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/registers/genre.vue